import axios from 'axios';
import type { Classification } from '../types/Employee';

const BASE_URL = process.env.REACT_APP_API_URL;

interface PaginatedResponse<T> {
  classifications: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const classificationService = {
  getClassifications: async (page: number = 1, limit: number = 25, filters?: { search?: string; serviceAreaId?: number }): Promise<PaginatedResponse<Classification>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });

    if (filters?.search && filters.search.trim()) {
      params.append('search', filters.search.trim());
    }
    if (filters?.serviceAreaId) {
      params.append('serviceAreaId', filters.serviceAreaId.toString());
    }

    const response = await axios.get(`${BASE_URL}/classifications?${params.toString()}`);
    return response.data;
  },

  getClassificationsByServiceArea: async (serviceAreaId: number): Promise<Classification[]> => {
    const response = await axios.get(`${BASE_URL}/classifications/service-area/${serviceAreaId}`);
    return response.data;
  },

  getClassification: async (id: number): Promise<Classification> => {
    const response = await axios.get(`${BASE_URL}/classifications/${id}`);
    return response.data;
  },

  createClassification: async (classificationData: { code: string; rate: number; serviceAreaId: number }): Promise<Classification> => {
    const response = await axios.post(`${BASE_URL}/classifications`, classificationData);
    return response.data;
  },

  updateClassification: async (id: number, classificationData: Partial<Classification>): Promise<Classification> => {
    const response = await axios.put(`${BASE_URL}/classifications/${id}`, classificationData);
    return response.data;
  },

  deleteClassification: async (id: number): Promise<void> => {
    await axios.delete(`${BASE_URL}/classifications/${id}`);
  },

  getClassificationsForRole: async (roleId: number): Promise<Classification[]> => {
    const response = await axios.get(`${BASE_URL}/classifications/role/${roleId}`);
    return response.data;
  },

  getAllClassifications: async (): Promise<Classification[]> => {
    const response = await axios.get(`${BASE_URL}/classifications/all`);
    return response.data;
  }
};
